/**
 * Command Center tab header — explains what the active section enables and its value.
 */
import React from 'react';
import type { DashboardTabMeta } from './dashboardTabMeta';
import { SectionExplainer, type, cn } from './kit';

interface DashboardTabHeaderProps {
  meta: DashboardTabMeta;
}

const DashboardTabHeader: React.FC<DashboardTabHeaderProps> = ({ meta }) => (
  <header
    className="mb-6 rounded-xl border border-cyan-900/40 bg-gradient-to-r from-slate-900/80 to-slate-950/80 p-4 md:p-5"
    data-testid={`dashboard-tab-header-${meta.id}`}
  >
    <div className="flex flex-wrap items-start gap-3 md:gap-4">
      <span className="text-2xl md:text-3xl shrink-0" aria-hidden>
        {meta.icon}
      </span>
      <div className="min-w-0 flex-1">
        <p className={cn(type.eyebrowAccent, 'mb-0.5')}>Command Center</p>
        <h2 className={cn(type.titleLg, 'md:text-xl')}>{meta.label}</h2>
        <p className={cn(type.body, 'mt-0.5')}>{meta.tagline}</p>
      </div>
    </div>

    <SectionExplainer
      enables={meta.enables}
      value={meta.value}
      actions={meta.actions}
      className="mt-4"
    />
  </header>
);

export default DashboardTabHeader;